namespace RioERP.Carts {
    export interface CartProductsForm {
        CartId: Serenity.IntegerEditor;
        ProductId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
        CartProductSpecificationId: Serenity.LookupEditor;
        Cost: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        NetAmountAfterFrDiscount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Note: Serenity.StringEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
    }

    export class CartProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.CartProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CartProductsForm.init)  {
                CartProductsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;

                Q.initFormType(CartProductsForm, [
                    'CartId', w0,
                    'ProductId', w1,
                    'Quantity', w0,
                    'CartProductSpecificationId', w1,
                    'Cost', w2,
                    'GrossAmount', w2,
                    'NetAmount', w2,
                    'NetAmountAfterFrDiscount', w2,
                    'TaxableAmount', w2,
                    'TaxAmount', w2,
                    'Note', w3,
                    'FranchiseeDiscountAmount', w2
                ]);
            }
        }
    }
}
